import { jsx as _jsx } from "react/jsx-runtime";
const CheckedIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "100%", height: "100%", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { id: "Vector", d: "M15.75 5.24988L6.75 14.2499L2.625 10.1249L3.6825 9.06738L6.75 12.1274L14.6925 4.19238L15.75 5.24988Z", fill: props.color }) })));
};
CheckedIcon.defaultProps = {
    color: 'white',
};
export default CheckedIcon;
